import { render, staticRenderFns } from "./Quicksearch.vue?vue&type=template&id=5510b38a&"
import script from "./Quicksearch.vue?vue&type=script&lang=js&"
export * from "./Quicksearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports